// Paleta compartida por los graficos de este dashboard. Se necesitan 10
// colores: uno por cada proveedor del Top 10 en el grafico de barras.
export const COLORES_COMPRA = ["#3b82f6", "#22c55e", "#8b5cf6", "#f97316", "#ef4444", "#06b6d4", "#eab308", "#64748b", "#ec4899", "#14b8a6"];
// Evolucion: periodo actual en azul y periodo anterior en gris (punteado).
export const COLORES_EVOLUCION = ["#3b82f6", "#94a3b8"];
export const NOMBRES_MES_CORTO = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Set", "Oct", "Nov", "Dic"];
